module.exports = __webpack_public_path__ + "img/cwg_jichengdianyuan.c0e5d557.png";